import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import * as Sentry from "@sentry/capacitor";
import * as SentryVue from "@sentry/vue";

import { IonicVue } from "@ionic/vue";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";

import "./vee-validate";

/* Theme variables */
import "./theme/variables.css";
import { createPinia } from "pinia";

import i18n from "./plugins/i18n";
import { initAnalytics } from "./plugins/analytics";

initAnalytics();

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(createPinia())
  .use(i18n);

router.isReady().then(() => {
  app.mount("#app");
});

Sentry.init(
  {
    app,
    dsn: "https://8d3127fedc5cb79374b6d998ac263f55@sentry.more.it/3",
    integrations: [
      SentryVue.browserTracingIntegration(),
      SentryVue.replayIntegration(),
    ],
    tracePropagationTargets: ["localhost"],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  },
  // Forward the init method from @sentry/vue
  SentryVue.init
);
